<template>
  <div>
    <page-header :title="$t('dictionary.companyinfo')" />
    <page-body need-margin-bottom>
      <a-form
        :form="form.fc"
        v-bind="formItemLayout"
        hideRequiredMark>
        <a-form-item :label="$t('system.companyinfo.name')" :extra="$t('system.text_111')">
          <a-input v-decorator="decorators.name" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.name_en')">
          <a-input v-decorator="decorators.name_en" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.login_layout')">
          <a-select v-decorator="decorators.login_layout" :placeholder="$t('system.companyinfo.login_layout')">
            <a-select-option value="normal">{{$t('system.companyinfo.login_layout_normal')}}</a-select-option>
            <a-select-option value="fullscreen">{{$t('system.companyinfo.login_layout_fullscreen')}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('system.text_114')" :extra="$t('system.text_115')">
          <image-cropper v-decorator="decorators.logo" :format="logoFormat" :w="76" :h="52" />
        </a-form-item>
        <a-form-item :label="$t('system.text_116')" :extra="$t('system.text_117')">
          <image-cropper v-decorator="decorators.login_logo" :format="loginLogoFormat" :w="280" :h="80" />
        </a-form-item>
        <a-form-item :label="$t('system.text_118')" :extra="$t('system.text_119')">
          <image-cropper v-decorator="decorators.favicon" :format="faviconFormat" :w="32" :h="32" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.login_page_backgroup_image')" :extra="form.fd.login_layout === 'fullscreen' ? $t('system.companyinfo.login_page_backgroup_image.extra1') : $t('system.companyinfo.login_page_backgroup_image.extra')">
          <image-cropper v-decorator="decorators.login_page_backgroup_image" :format="loginBgFormat" :w="320" :h="form.fd.login_layout === 'fullscreen' ? 228 : 200" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.login_page_slogan')">
          <a-input v-decorator="decorators.login_page_slogan" :placeholder="$t('system.login_slogan_placeholder')" />
          <span class="ml-1 mr-1">{{ $t('system.companyinfo.font_color') }}: </span>
          <oc-color-picker v-decorator="decorators.login_page_slogan_color" />
          <span class="ml-1">{{ form.fc.getFieldValue('login_page_slogan_color')}}</span>
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.login_page_sub_slogan')">
          <a-input v-decorator="decorators.login_page_sub_slogan" :placeholder="$t('system.login_slogan_placeholder')" />
          <span class="mr-1">{{ $t('system.companyinfo.font_color') }}: </span>
          <oc-color-picker v-decorator="decorators.login_page_sub_slogan_color" />
          <span class="ml-1">{{ form.fc.getFieldValue('login_page_sub_slogan_color')}}</span>
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.login_page_slogan_en')">
          <a-input v-decorator="decorators.login_page_slogan_en" :placeholder="$t('system.login_slogan_placeholder')" />
          <span class="mr-1">{{ $t('system.companyinfo.font_color') }}: </span>
          <oc-color-picker v-decorator="decorators.login_page_slogan_en_color" />
          <span class="ml-1">{{ form.fc.getFieldValue('login_page_slogan_en_color')}}</span>
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.login_page_sub_slogan_en')">
          <a-input v-decorator="decorators.login_page_sub_slogan_en" :placeholder="$t('system.login_slogan_placeholder')" />
          <span class="mr-1">{{ $t('system.companyinfo.font_color') }}: </span>
          <oc-color-picker v-decorator="decorators.login_page_sub_slogan_en_color" />
          <span class="ml-1">{{ form.fc.getFieldValue('login_page_sub_slogan_en_color')}}</span>
        </a-form-item>
        <a-form-item v-if="!$store.getters.isSysCE" :label="$t('system.companyinfo.monitor_dashboard_name')">
          <a-input v-decorator="decorators.monitor_dashboard_name" :placeholder="$t('system.text_111')" />
          <span class="mr-1">{{ $t('system.companyinfo.font_color') }}: </span>
          <oc-color-picker v-decorator="decorators.monitor_dashboard_name_color" />
          <span class="ml-1">{{ form.fc.getFieldValue('monitor_dashboard_name_color')}}</span>
        </a-form-item>
        <a-form-item v-if="!$store.getters.isSysCE" :label="$t('system.companyinfo.monitor_dashboard_name_en')">
          <a-input v-decorator="decorators.monitor_dashboard_name_en" />
          <span class="mr-1">{{ $t('system.companyinfo.font_color') }}: </span>
          <oc-color-picker v-decorator="decorators.monitor_dashboard_name_en_color" />
          <span class="ml-1">{{ form.fc.getFieldValue('monitor_dashboard_name_en_color')}}</span>
        </a-form-item>
        <a-form-item v-if="!$store.getters.isSysCE" :label="$t('system.companyinfo.monitor_dashboard_logo')" :extra="$t('system.companyinfo.monitor_dashboard_logo.extra')">
          <image-cropper v-decorator="decorators.monitor_dashboard_logo" :format="monitorDashboardLogoFormat" :w="76" :h="52" />
        </a-form-item>
        <a-form-item v-if="!$store.getters.isSysCE" :label="$t('system.companyinfo.monitor_dashboard_style')">
          <a-row :gutter="8">
            <a-col :span="6">
              <a-form-item>
                <oc-select
                  width="100%"
                  v-decorator="decorators.monitor_dashboard_style"
                  :data="[
                    {key: 'overview-custom', label: $t('system.companyinfo.monitor_dashboard_style.overview_custom')},
                    {key: 'overview', label: $t('system.companyinfo.monitor_dashboard_style.overview')},
                    {key: 'overview-private', label: $t('system.companyinfo.monitor_dashboard_style.overview_private')},
                    {key: 'overview-private2', label: $t('system.companyinfo.monitor_dashboard_style.overview_private2')},
                    {key: 'custom-url', label: $t('system.companyinfo.monitor_dashboard_style.custom_url')},
                  ]" />
              </a-form-item>
            </a-col>
            <a-col :span="10" v-if="form.fd.monitor_dashboard_style === 'custom-url'">
              <a-form-item>
                <a-input v-decorator="decorators.custom_url" :placeholder="$t('common.tips.input', [$t('system.companyinfo.monitor_dashboard_custom_url')])" />
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-button v-if="form.fd.monitor_dashboard_style === 'custom-url'" type="link" :disabled="!form.fd.custom_url" @click="openUrl">{{ $t('common.view') }}</a-button>
              <a-button
                v-else
                type="link"
                @click="overviewClickHandle(form.fc.getFieldValue('monitor_dashboard_style'))">
                {{ $t('common.text00100') }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.copyright')" :extra="$t('system.text_113')">
          <a-input v-decorator="decorators.copyright" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.copyright_en')">
          <a-input v-decorator="decorators.copyright_en" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.totp_issuer')">
          <a-input v-model="totp_issuer" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.inner_copyright')">
          <a-input v-decorator="decorators.inner_copyright" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.inner_copyright_en')">
          <a-input v-decorator="decorators.inner_copyright_en" />
        </a-form-item>
        <a-form-item :label="$t('system.companyinfo.inner_logo')" :extra="$t('system.companyinfo.inner_logo.extra')">
          <image-cropper v-decorator="decorators.inner_logo" :format="innerLogoFormat" :w="64" :h="64" />
        </a-form-item>
      </a-form>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button class="mr-2" :loading="loading" @click="reset" size="large">{{ $t('system.revoke') }}</a-button>
        <a-button type="primary" @click="handleConfirm" :loading="submiting" size="large">{{$t('system.text_120')}}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapState } from 'vuex'
import WindowsMixin from '@/mixins/windows'
import ImageCropper from './components/ImageCropper'
import OcColorPicker from './components/ColorPicker'

const DEFAULT_COLOR = '#000000'
const DEFAULT_OVERVIEW = 'overview-custom'

export default {
  name: 'CompanyInfoIndex',
  components: {
    ImageCropper,
    OcColorPicker,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      loading: false,
      submiting: false,
      form: {
        fc: this.$form.createForm(this, {
          onValuesChange: this.handleValuesChange,
        }),
        fd: {
          monitor_dashboard_style: '',
        },
      },
      decorators: {
        name: [
          'name',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.name')]),
                transform: val => val && R.trim(val),
              },
              {
                max: 25,
                message: this.$t('system.text_111'),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        name_en: [
          'name_en',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.name_en')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        login_layout: [
          'login_layout',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.login_layout')]),
              },
            ],
          },
        ],
        login_page_slogan: [
          'login_page_slogan',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.login_page_slogan')]),
                transform: val => val && R.trim(val),
              },
              {
                // max: 25,
                message: this.$t('system.text_111'),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        login_page_slogan_en: [
          'login_page_slogan_en',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.login_page_slogan_en')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        login_page_sub_slogan: [
          'login_page_sub_slogan',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.login_page_sub_slogan')]),
                transform: val => val && R.trim(val),
              },
              {
                // max: 25,
                message: this.$t('system.text_111'),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        login_page_sub_slogan_en: [
          'login_page_sub_slogan_en',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.login_page_sub_slogan_en')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        monitor_dashboard_name: [
          'monitor_dashboard_name',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.monitor_dashboard_name')]),
                transform: val => val && R.trim(val),
              },
              {
                max: 25,
                message: this.$t('system.text_111'),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        monitor_dashboard_name_en: [
          'monitor_dashboard_name_en',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.monitor_dashboard_name_en')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        custom_url: [
          'custom_url',
          {
            validateFirst: false,
            rules: [
              {
                required: true,
                transform: val => val && R.trim(val),
                validator: this.$validate('url'),
              },
            ],
          },
        ],
        copyright: [
          'copyright',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.copyright')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        copyright_en: [
          'copyright_en',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.copyright_en')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        inner_copyright: [
          'inner_copyright',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.inner_copyright')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        inner_copyright_en: [
          'inner_copyright_en',
          {
            validateFirst: false,
            rules: [
              {
                required: false,
                message: this.$t('system.text_242', [this.$t('system.companyinfo.inner_copyright_en')]),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        logo: [
          'logo',
        ],
        login_logo: [
          'login_logo',
        ],
        inner_logo: ['inner_logo'],
        monitor_dashboard_logo: [
          'monitor_dashboard_logo',
        ],
        login_page_backgroup_image: [
          'login_page_backgroup_image',
        ],
        favicon: [
          'favicon',
        ],
        login_page_slogan_color: [
          'login_page_slogan_color',
          {
            initialValue: DEFAULT_COLOR,
          },
        ],
        login_page_slogan_en_color: [
          'login_page_slogan_en_color',
          {
            initialValue: DEFAULT_COLOR,
          },
        ],
        login_page_sub_slogan_color: [
          'login_page_sub_slogan_color',
          {
            initialValue: DEFAULT_COLOR,
          },
        ],
        login_page_sub_slogan_en_color: [
          'login_page_sub_slogan_en_color',
          {
            initialValue: DEFAULT_COLOR,
          },
        ],
        monitor_dashboard_name_color: [
          'monitor_dashboard_name_color',
          {
            initialValue: '#ffffff',
          },
        ],
        monitor_dashboard_name_en_color: [
          'monitor_dashboard_name_en_color',
          {
            initialValue: '#ffffff',
          },
        ],
        monitor_dashboard_style: [
          'monitor_dashboard_style',
          {
            initialValue: DEFAULT_OVERVIEW,
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      totp_issuer: this.$store.state.common.yunionapiGlobalConfig?.totp_issuer,
    }
  },
  computed: {
    ...mapState('app', {
      companyInfo: state => state.companyInfo,
    }),
    logoFormat () {
      return this.companyInfo.logo_format
    },
    loginLogoFormat () {
      return this.companyInfo.login_logo_format
    },
    innerLogoFormat () {
      return this.companyInfo.inner_logo_format
    },
    faviconFormat () {
      return this.companyInfo.favicon_format
    },
    loginBgFormat () {
      return this.companyInfo.login_page_backgroup_image_format
    },
    monitorDashboardLogoFormat () {
      return this.companyInfo.monitor_dashboard_logo_format
    },
  },
  watch: {
    companyInfo: {
      handler (val) {
        this.$nextTick(() => {
          this.form.fc.setFieldsValue({
            name: this.formatValue(val.name),
            name_en: this.formatValue(val.name_en),
            login_layout: val.login_layout || 'normal',
            logo: this.formatValue(val.logo),
            login_logo: this.formatValue(val.login_logo),
            favicon: this.formatValue(val.favicon),
            login_page_backgroup_image: this.formatValue(val.login_page_backgroup_image),
            login_page_slogan: this.formatValue(val.login_page_slogan),
            login_page_sub_slogan: this.formatValue(val.login_page_sub_slogan),
            login_page_slogan_en: this.formatValue(val.login_page_slogan_en),
            login_page_sub_slogan_en: this.formatValue(val.login_page_sub_slogan_en),
            monitor_dashboard_name: this.formatValue(val.monitor_dashboard_name),
            monitor_dashboard_name_en: this.formatValue(val.monitor_dashboard_name_en),
            monitor_dashboard_logo: this.formatValue(val.monitor_dashboard_logo),
            copyright: this.formatValue(val.copyright),
            copyright_en: this.formatValue(val.copyright_en),
            login_page_slogan_color: val.login_page_slogan_color || DEFAULT_COLOR,
            login_page_slogan_en_color: val.login_page_slogan_en_color || DEFAULT_COLOR,
            login_page_sub_slogan_color: val.login_page_sub_slogan_color || DEFAULT_COLOR,
            login_page_sub_slogan_en_color: val.login_page_sub_slogan_en_color || DEFAULT_COLOR,
            monitor_dashboard_name_color: val.monitor_dashboard_name_color || '#ffffff',
            monitor_dashboard_name_en_color: val.monitor_dashboard_name_en_color || '#ffffff',
            monitor_dashboard_style: val.monitor_dashboard_style || DEFAULT_OVERVIEW,
            inner_copyright: this.formatValue(val.inner_copyright),
            inner_copyright_en: this.formatValue(val.inner_copyright_en),
            inner_logo: this.formatValue(val.inner_logo),
          })
        })
      },
      immediate: true,
    },
  },
  destroyed () {
    this.manager = null
  },
  created () {
    this.manager = new this.$Manager('infos', 'v1')
  },
  methods: {
    async handleValuesChange (vm, changedFields) {
      const fields = Object.keys(changedFields)
      if (changedFields && fields.length > 0) {
        fields.forEach(field => {
          this.$set(this.form.fd, field, changedFields[field])
        })
      }
    },
    formatValue (val) {
      if (!val || val === 'undefined') {
        return ''
      }
      return val
    },
    async handleConfirm () {
      this.submiting = true
      try {
        const values = await this.form.fc.validateFields()
        const fd = new FormData()
        R.forEachObjIndexed((value, key) => {
          let val = value
          const imgKeys = ['logo', 'login_logo', 'inner_logo', 'favicon', 'login_page_backgroup_image', 'monitor_dashboard_logo']
          if (!value || value === 'undefined') {
            val = ''
          } else if (imgKeys.includes(key)) {
            val = `data:image/png;base64,${val}`
          }
          fd.append(key, val)
        }, values)
        await this.manager.create({
          data: fd,
        })
        await this.$store.dispatch('app/fetchCompayInfo')
        if (this.$store.getters.common.yunionapiGlobalConfig?.totp_issuer !== this.totp_issuer) {
          const servicesManager = new this.$Manager('services', 'v1')
          const serviceRes = await servicesManager.list({
            params: { type: ['yunionapi'] },
          })
          const serviceId = serviceRes.data?.data?.[0]?.id
          if (serviceId) {
            await servicesManager.performAction({
              id: serviceId,
              action: 'config',
              data: {
                action: 'update',
                config: {
                  default: {
                    totp_issuer: this.totp_issuer,
                  },
                },
              },
            })
            this.$store.commit('common/UPDATE_OBJECT', { name: 'yunionapiGlobalConfig', data: { totp_issuer: this.totp_issuer } })
          }
        }
        this.$message.success(this.$t('system.text_124', [this.$t('dictionary.companyinfo')]))
      } catch (error) {
        throw error
      } finally {
        this.submiting = false
      }
    },
    overviewClickHandle (monitor_dashboard_style) {
      this.createDialog('OverViewDialog', {
        type: monitor_dashboard_style,
      })
    },
    openUrl () {
      window.open(this.form.fd.custom_url, '__blank')
    },
    async reset () {
      try {
        this.loading = true
        const fd = new FormData()
        fd.append('reset', true)
        await this.manager.performClassAction({
          action: 'reset',
          data: fd,
        })
        await this.$store.dispatch('app/fetchCompayInfo')
        this.$message.success(this.$t('system.text_124', [this.$t('dictionary.companyinfo')]))
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
